// extracted by mini-css-extract-plugin
export default {"inputContainer":"CreatorChat_inputContainer__72hdq","querySectionText":"CreatorChat_querySectionText__4rsu0","querySectionText_2":"CreatorChat_querySectionText_2__AlQZY"};